import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/Logo_LacStLouis_Logo_jaune_et_noir.png';

const Header = () => {
  const { isAuthenticated, logout, user } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img 
              src={logo} 
              alt="Logo" 
              style={{ height: '40px', marginRight: '10px' }}
            />
            Questionnaires
          </Link>
          <nav className="nav">
            <Link to="/">Accueil</Link>
            {process.env.NODE_ENV === 'development' && (
              <Link to="/test-auth">Test Auth</Link>
            )}
            {isAuthenticated && (
              <>
                <Link to="/dashboard">Tableau de Bord</Link>
                {user && user.email === 'jean.philippe.robichaud@gmail.com' && (
                  <Link to="/admin">Admin</Link>
                )}
                <button 
                  onClick={handleLogout}
                  className="btn btn-secondary"
                >
                  Se Déconnecter
                </button>
              </>
            )}
            {!isAuthenticated && (
              <Link to="/auth" className="btn btn-primary">
                Se Connecter
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;